import React, { useState, useEffect, useRef, useContext } from 'react';
import AssignmentEditor from './AssignmentEditor';
import { DataContext as MainDataContext } from '../../../../store';

const AssignmentEditorContainer = ({ row, outerDivStyle, outerDivClassName, initialAssignment, textContent, createStartWeek }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const {
        store: { user },
    } = useContext(MainDataContext);
    const hasEditingPermission = user.isAdmin;

    const dropdown = useRef();
    const dropdownToggle = useRef();

    const creatingAssignment = initialAssignment === null;
    const createIcon = 'oi oi-plus card shadow-sm';
    const [showCreate, setShowCreate] = useState(false);

    const handleClose = () => {
        setShowCreate(false);
        setIsOpen(false);
    };

    const handleKeyDown = (e) => {
        // Escape button
        if (e.keyCode === 27) {
            handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick, false);
        document.addEventListener('keydown', handleKeyDown, false);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick, false);
            document.removeEventListener('keydown', handleKeyDown, false);
        };
    });

    const handleDocumentClick = (e) => {
        if (dropdown.current && dropdownToggle.current) {
            if (!dropdown.current.contains(e.target) && !dropdownToggle.current.contains(e.target)) {
                if (!isAlertModalOpen && !isDeleteModalOpen) {
                    handleClose();
                }
            }
        }
    };

    const handleDropdownClick = (e) => {
        if (!dropdownToggle.current) {
            return;
        }
        if (dropdown.current) {
            if (!dropdown.current.contains(e.target)) {
                if (!isAlertModalOpen && !isDeleteModalOpen) {
                    handleClose();
                }
            }
        } else {
            if (dropdownToggle.current.contains(e.target)) {
                setIsOpen(true);
            }
        }
    };

    const handleMouseEnter = () => {
        setShowCreate(true);
    };
    const handleMouseLeave = () => {
        if (!isOpen) {
            setShowCreate(false);
        }
    };

    if (creatingAssignment) {
        if (!hasEditingPermission) {
            return <div style={outerDivStyle}></div>;
        }
        return (
            <div
                className={'dropdown assignment-editor-container'}
                align='center'
                style={outerDivStyle}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={handleDropdownClick}
                ref={dropdownToggle}>
                {showCreate && hasEditingPermission && <div style={outerDivStyle} className={createIcon}></div>}
                {isOpen && (
                    <AssignmentEditor
                        initialAssignment={initialAssignment}
                        row={row}
                        dropdownRef={dropdown}
                        handleClose={handleClose}
                        createStartWeek={createStartWeek}
                        isAlertModalOpen={isAlertModalOpen}
                        setIsAlertModalOpen={setIsAlertModalOpen}
                        isDeleteModalOpen={isDeleteModalOpen}
                        setIsDeleteModalOpen={setIsDeleteModalOpen}
                    />
                )}
            </div>
        );
    } else {
        return (
            <div
                className={outerDivClassName + ' dropdown assignment-editor-container'}
                style={outerDivStyle}
                onClick={handleDropdownClick}
                ref={dropdownToggle}>
                {textContent}
                {isOpen && (
                    <AssignmentEditor
                        initialAssignment={initialAssignment}
                        row={row}
                        dropdownRef={dropdown}
                        handleClose={handleClose}
                        isAlertModalOpen={isAlertModalOpen}
                        setIsAlertModalOpen={setIsAlertModalOpen}
                        isDeleteModalOpen={isDeleteModalOpen}
                        setIsDeleteModalOpen={setIsDeleteModalOpen}
                    />
                )}
            </div>
        );
    }
};

export default AssignmentEditorContainer;
